
import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import Button from 'components/partials/button/button';
import Icons from 'assets/icons';

export const NoToplineGoals = (): React.JSX.Element => (
  <Stack
    sx={{
      flex: '1 1 0%',
      bgcolor: 'tokens.navy.50',
      p: 2,
      borderRadius: '0.5rem',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <p className="text-lg font-bold text-center mb-2">
      Your Topline Goals are missing.
    </p>
    <p className="text-center">
      Please contact the MARKETview success team to set them up.
    </p>
  </Stack>
);

interface NoGoalsDefinedProps {
  handleEmailClick: () => void;
}

export const NoGoalsDefined = ({
  handleEmailClick,
}: NoGoalsDefinedProps): React.JSX.Element => (
  <Stack
    sx={{
      height: '100%',
      bgcolor: 'tokens.navy.800',
      borderRadius: '0.5rem',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      p: 2.5,
      pt: 0,
    }}
  >
    <p className="text-white font-bold text-lg">Your goals are missing.</p>

    <p className="text-white mb-5 leading-6">
      Please contact your MARKETview success team to set them up.
    </p>

    <Button
      variant="brand-filled"
      size="sm"
      onClick={handleEmailClick}
      iconAfter={<Icons.DoubleArrow />}
    >
      Speak to Us
    </Button>
  </Stack>
);

export const SkeletonLoader = (): React.JSX.Element => (
  <div className="h-full bg-white border border-gray-200 rounded-lg flex flex-col p-5 animate-pulse">
    <Stack direction="row" sx={{ alignItems: 'center', gap: 1, mb: 2 }}>
      <Box
        sx={{
          height: '1.25rem',
          width: '1.25rem',
          bgcolor: 'tokens.gray.300',
          borderRadius: '9999px',
        }}
      />
      <Box
        sx={{
          height: '1.25rem',
          width: '8rem',
          bgcolor: 'tokens.gray.300',
          borderRadius: '0.25rem',
        }}
      />
    </Stack>
    <div className="sr-only">Loading...</div>
    <Stack
      direction="row"
      sx={{
        flex: '1 1 0%',
        bgcolor: 'tokens.gray.50',
        p: 2,
        borderRadius: '0.5rem',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          height: '2rem',
          width: '4rem',
          bgcolor: 'tokens.gray.300',
          borderRadius: '0.25rem',
        }}
      />
    </Stack>
    <Box
      sx={{
        height: '2rem',
        width: '6rem',
        bgcolor: 'tokens.gray.300',
        borderRadius: '0.25rem',
        mt: 2,
      }}
    />
  </div>
);
